import { withBlockExtensions } from '@plone/volto/helpers/Extensions';

import ServicesBody from './ServicesBody';

const View = (props) => <ServicesBody {...props} />;

export default withBlockExtensions(View);
